import c from "./lib/createApi";

export default {
  types: c("GET", "/v1/terms/type", false), // [약관 -2] 약관 타입
  get: c("GET", "/v1/terms/recent", false), // [약관 -2] 최신 약관 불러오기
};
